'use strict';

export function init() {
    const nav = document.querySelector('.concert-navigation');
    const navInner = document.querySelector('.concert-navigation__inner');
    const navLine = (nav) ? nav.querySelector('.concert-navigation__line') : false;
    const navLink = document.querySelectorAll('.concert-navigation__link');
    const active = document.querySelector('.concert-navigation__link.active');
    const navBtn = document.querySelector('.concert-nav-btn');
    const navList = document.querySelector('.concert-navigation__list');

    let pos = 0;
    let wid = 0;
    let animating = false;

    //Underline initial active item
    function setUnderline() {
        if (active && navLine) {
            pos = active.getBoundingClientRect().left;
            wid = active.getBoundingClientRect().width;
            navLine.style.left = active.offsetLeft + "px";
            navLine.style.width = wid + "px";
        }
    }

    const updateMarginRight = () => {
        const navWidth = navInner.offsetWidth;
        const navListWidth = navList.offsetWidth;
        const rightMargin = (navWidth - navListWidth)  + 'px';
    
        if (nav.classList.contains('is-sticky')) {
            navList.style.marginRight = rightMargin;
        } else {
            navList.style.marginRight = '0px';
        }
    };

    if (nav) {
        setUnderline();

        if (navBtn) {
            const globalAlert = document.querySelector('.global-alert');
            let offset = 0;

            if (globalAlert) {
                offset = globalAlert.offsetHeight;
            }
            navBtn.addEventListener('click', function() {
                window.scrollTo({
                    top: document.querySelector('#concert-booking').offsetTop - offset,
                    behavior: 'smooth'
                });
            });
        }

        const checkSticky = () => {
            const rect = nav.getBoundingClientRect();
        
            if (rect.top < 0 && !nav.classList.contains('is-sticky')) {
                nav.classList.add('is-sticky');
                setTimeout(function(){
                    setUnderline();
                }, 400);
            } else if (rect.top > 0 && nav.classList.contains('is-sticky')) {
                nav.classList.remove('is-sticky');
                setTimeout(function(){
                    setUnderline();
                }, 400);
            }
        
            updateMarginRight();
        };

        checkSticky();

        window.addEventListener('scroll', checkSticky);

        window.addEventListener('resize', checkSticky);

        //Underline animation function
        const underline = element => {

            if (element.classList.contains('active') || animating === true) {
                return null;
            } else {

                animating = true;

                nav.querySelectorAll('a').forEach(function (e) {
                    return e.classList.remove('active');
                });

                element.classList.add('active');

                let position = element.getBoundingClientRect();
                let width = position.width;

                if (position.x >= pos) {
                    navLine.style.width = position.x - pos + width + 'px';
                    setTimeout(function () {
                        navLine.style.left = element.offsetLeft + 'px';
                        navLine.style.width = width + 'px';
                        navLine.style.transitionDuration = '200ms';
                        animating = false;

                    }, 300);
                } else {
                    navLine.style.width = pos - position.left + wid + 'px';
                    navLine.style.left = element.offsetLeft + 'px';
                    setTimeout(function () {
                        navLine.style.width = width + 'px';
                        navLine.style.transitionDuration = '200ms';
                        animating = false;
                    }, 300);
                }

                pos = position.left;
                wid = width;

            }

        };

        window.onresize = function () {
            let resizeDebounce;
            clearTimeout(resizeDebounce);

            resizeDebounce = setTimeout(function () {
                underline(active);
            }, 150);
        };

        window.addEventListener('scroll', function() {
            let scrollDebounce;
            clearTimeout(scrollDebounce);

        scrollDebounce = setTimeout(function () {
            navLink.forEach(selector  => {
                let scrollOffset = selector.dataset.scrollOffset;
                let targetHash = selector.hash;
                let targetDimensions = document.querySelector(targetHash).getBoundingClientRect();
                let targetTop = targetDimensions.top;
                let concertNavHeight = nav.getBoundingClientRect().height;

                    if (scrollOffset) {
                        targetTop = (targetTop - scrollOffset)
                    }

                    if (targetTop <= concertNavHeight && targetTop + targetDimensions.height > concertNavHeight) {
                        underline(selector);
                    }
                });
            }, 150);
        });
    }
}

export default { init }
